const Lawyer = () => import('./Lawyer.vue')

export {
  Lawyer
}



// WEBPACK FOOTER //
// ./src/pages/lawyer/index.js